<div
  class="home-mobile-page flex flex-col h-full md:h-auto overflow-y-auto md:overflow-visible overflow-x-hidden bg-white dark:bg-[var(--color-dark-bg-primary)]">
  <div
    class="home-mobile-scroll flex-1 overflow-y-auto md:overflow-visible [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">

    <!-- Profile menu bar -->
    <div class="hidden md:flex justify-end px-4 sm:px-6 lg:px-8 pt-2">
      <app-profile-menu></app-profile-menu>
    </div>

    @if (home.isLoadingExpertCards && home.expertCards.length === 0 && home.isLoadingChats && home.recentChats.length
    === 0 && platformUsersFacade.isLoadingPlatformUsers && platformUsersFacade.platformUsers.length === 0) {
    <div class="py-10 flex items-center justify-center">
      <app-loader label="Cargando inicio..." size="md"></app-loader>
    </div>
    }

    <app-home-hero-section [userName]="home.userName" [chatMessage]="home.chatMessage"
      [currentPrompt]="home.currentQuickPrompt" [nextPrompt]="home.nextQuickPrompt"
      [hasQuickPrompts]="home.visibleQuickActionPrompts.length > 0" [isPromptTransitioning]="home.isPromptTransitioning"
      (chatMessageChange)="home.chatMessage = $event" (sendRequested)="home.sendChatMessage()"
      (quickPromptSelected)="home.sendPromptWithExpert($event.prompt, $event.expert)"></app-home-hero-section>

    <app-home-experts-section [expertCards]="home.expertCardsView" [isLoading]="home.isLoadingExpertCards"
      [activeCount]="home.activeExpertCount" [totalCount]="home.totalExpertCount"
      (expertSelected)="home.goToExpertChat($event)"></app-home-experts-section>

    <!-- Mi Empresa & Conexiones Section -->
    <div class="home-mobile-section-shell w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-12">
      <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">

        <app-home-company-summary [progress]="home.companyProfileProgress" [documentCount]="home.documentCount"
          (completeRequested)="home.goToCompleteCompany()"></app-home-company-summary>

        <app-home-connections-section [totalCount]="home.totalConnectionsCount" [connectedCount]="home.connectedCount"
          [disconnectedCount]="home.disconnectedCount" [comingSoonCount]="home.comingSoonCount"
          [connectedConnections]="home.connectedConnectionsView"
          (manageConnection)="home.goToConnection($event)"></app-home-connections-section>

      </div>
    </div>

    <!-- Uso de la plataforma -->
    <div class="home-mobile-section-shell w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-12">
      <div class="home-mobile-section-heading flex items-start gap-3 mb-4">
        <div class="home-mobile-section-accent w-1 h-8 bg-[#3D3DF4] rounded-full shrink-0"></div>
        <h2 class="text-lg font-bold text-gray-900 dark:text-white leading-tight">Uso de la plataforma</h2>
      </div>
      <div
        class="home-mobile-surface home-mobile-platform-surface bg-white dark:bg-[var(--color-dark-bg-secondary)] border border-gray-200 dark:border-gray-700 rounded-2xl overflow-hidden">
        <!-- Filtro y contador (fondo gris) -->
        <div
          class="home-mobile-filter-bar flex items-center justify-between px-3 md:px-6 py-4 bg-[#F9FAFB] dark:bg-[var(--color-dark-bg-primary)] border-b border-gray-100 dark:border-gray-700">
          <select [(ngModel)]="platformUsersFacade.platformDepartmentFilter"
            (ngModelChange)="platformUsersFacade.applyPlatformFilter()"
            class="home-mobile-filter-select text-sm font-medium text-gray-700 dark:text-gray-300 bg-white dark:bg-[var(--color-dark-bg-secondary)] border border-gray-200 dark:border-gray-700 rounded-lg px-3 py-2 pr-8 outline-none cursor-pointer appearance-none"
            style="background-image: url('data:image/svg+xml;charset=UTF-8,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 20 20%22 fill=%22%236B7280%22%3E%3Cpath fill-rule=%22evenodd%22 d=%22M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z%22 clip-rule=%22evenodd%22/%3E%3C/svg%3E'); background-repeat: no-repeat; background-position: right 0.5rem center; background-size: 1.25rem;">
            <option value="">Todos los departamentos</option>
            @for (dept of platformUsersFacade.platformDepartments; track dept) {
            <option [value]="dept">{{ dept }}</option>
            }
          </select>
          <span class="home-mobile-filter-count text-xs md:text-sm text-gray-500 dark:text-gray-400">
            Mostrando <strong class="text-gray-900 dark:text-white">{{ platformUsersFacade.filteredPlatformUsers.length
              }}</strong> usuarios
          </span>
        </div>

        <!-- Tabla -->
        @if (platformUsersFacade.isLoadingPlatformUsers) {
        <div class="py-8 pr-4 flex items-center justify-center">
          <app-loader label="Cargando usuarios..." size="md"></app-loader>
        </div>
        } @else if (platformUsersFacade.filteredPlatformUsers.length === 0) {
        <div class="text-center py-8 text-gray-500 dark:text-gray-400">No hay usuarios.</div>
        } @else {
        <div class="overflow-x-auto px-3 xl:px-6 w-full hidden md:block">
          <table class="w-full table-auto min-w-[700px]">
            <thead>
              <tr class="border-b mx-2 border-gray-100 dark:border-gray-700">
                <th
                  class="text-left text-[10px] font-bold text-gray-400 dark:text-gray-500 uppercase tracking-wider py-3 pl-6 pr-2 cursor-pointer select-none"
                  (click)="platformUsersFacade.platformSortBy('name')">
                  <span class="inline-flex items-center gap-1">Usuario
                    <fa-icon [icon]="faArrowDownArrowUp" class="text-[10px] transition-transform"
                      [ngClass]="platformUsersFacade.getPlatformSortIcon('name')"></fa-icon>
                  </span>
                </th>
                <th
                  class="text-left text-[10px] font-bold text-gray-400 dark:text-gray-500 uppercase tracking-wider py-3 px-2 cursor-pointer select-none"
                  (click)="platformUsersFacade.platformSortBy('email')">
                  <span class="inline-flex items-center gap-1">Email
                    <fa-icon [icon]="faArrowDownArrowUp" class="text-[10px] transition-transform"
                      [ngClass]="platformUsersFacade.getPlatformSortIcon('email')"></fa-icon>
                  </span>
                </th>
                <th
                  class="text-left text-[10px] font-bold text-gray-400 dark:text-gray-500 uppercase tracking-wider py-3 px-2 cursor-pointer select-none"
                  (click)="platformUsersFacade.platformSortBy('department')">
                  <span class="inline-flex items-center gap-1">Departamento
                    <fa-icon [icon]="faArrowDownArrowUp" class="text-[10px] transition-transform"
                      [ngClass]="platformUsersFacade.getPlatformSortIcon('department')"></fa-icon>
                  </span>
                </th>
                <th
                  class="text-center text-[10px] font-bold text-gray-400 dark:text-gray-500 uppercase tracking-wider py-3 px-2 cursor-pointer select-none"
                  (click)="platformUsersFacade.platformSortBy('agents')">
                  <span class="inline-flex items-center justify-center gap-1">Agentes
                    <fa-icon [icon]="faArrowDownArrowUp" class="text-[10px] transition-transform"
                      [ngClass]="platformUsersFacade.getPlatformSortIcon('agents')"></fa-icon>
                  </span>
                </th>
                <th
                  class="text-center text-[10px] font-bold text-gray-400 dark:text-gray-500 uppercase tracking-wider py-3 px-2 cursor-pointer select-none"
                  (click)="platformUsersFacade.platformSortBy('is_active')">
                  <span class="inline-flex items-center justify-center gap-1">Estado
                    <fa-icon [icon]="faArrowDownArrowUp" class="text-[10px] transition-transform"
                      [ngClass]="platformUsersFacade.getPlatformSortIcon('is_active')"></fa-icon>
                  </span>
                </th>
                <th
                  class="text-right text-[10px] font-bold text-gray-400 dark:text-gray-500 uppercase tracking-wider py-3 pl-2 pr-6 cursor-pointer select-none"
                  (click)="platformUsersFacade.platformSortBy('query_count')">
                  <span class="inline-flex items-center justify-end gap-1">Querys
                    <fa-icon [icon]="faArrowDownArrowUp" class="text-[10px] transition-transform"
                      [ngClass]="platformUsersFacade.getPlatformSortIcon('query_count')"></fa-icon>
                  </span>
                </th>
              </tr>
            </thead>
            <tbody>
              @for (user of platformUsersFacade.filteredPlatformUsers; track user.id) {
              <tr class="border-b border-gray-50 dark:border-gray-800 last:border-0">
                <!-- Usuario -->
                <td class="py-3.5 pl-6 px-2">
                  <div class="flex items-center gap-3">
                    <div
                      class="w-9 h-9 rounded-full flex items-center justify-center text-white text-xs font-bold shrink-0"
                      [style.background-color]="platformUsersFacade.getUserAvatarColor(user)">
                      {{ platformUsersFacade.getUserInitials(user) }}
                    </div>
                    <div>
                      <p
                        class="text-xs xl:text-sm font-medium text-gray-900 dark:text-white leading-snug truncate max-w-[160px]">
                        {{ user.name }} {{ user.last_name ? user.last_name.charAt(0) + '.' : '' }}
                      </p>
                    </div>
                  </div>
                </td>
                <!-- Email -->
                <td class="py-3.5 px-2 text-xs xl:text-sm text-gray-500 dark:text-gray-400">
                  <span class="truncate block max-w-[200px]">{{ user.email }}</span>
                </td>
                <!-- Departamento -->
                <td class="py-3.5 px-2 text-xs xl:text-sm text-gray-500 dark:text-gray-400 uppercase whitespace-nowrap">
                  {{ platformUsersFacade.getUserDepartment(user) }}
                </td>
                <!-- Agentes -->
                <td class="py-3.5 px-2">
                  <div class="flex items-center justify-center flex-nowrap -space-x-1 mx-auto">
                    @for (icon of platformUsersFacade.getUserAgentIcons(user); track icon.path) {
                    <div
                      class="w-7 h-7 rounded-full flex items-center justify-center border-2 border-white dark:border-[var(--color-dark-bg-secondary)]"
                      [style.background-color]="icon.bg" [class.opacity-30]="icon.disabled"
                      [class.grayscale]="icon.disabled">
                      <img [src]="icon.path" alt="" class="w-3.5 h-3.5">
                    </div>
                    }
                  </div>
                </td>
                <!-- Estado -->
                <td class="py-3.5 px-2 text-center whitespace-nowrap">
                  <div class="flex items-center justify-center gap-2">
                    <span class="w-2 h-2 rounded-full" [class.bg-green-500]="user.is_active !== false"
                      [class.bg-red-400]="user.is_active === false"></span>
                    <span class="text-xs xl:text-sm text-gray-600 dark:text-gray-300">{{ user.is_active !== false ?
                      'Activo' :
                      'Inactivo' }}</span>
                  </div>
                </td>
                <!-- Querys -->
                <td class="py-3.5 px-2 pr-6 text-right">
                  <span class="text-xs xl:text-sm font-bold text-gray-900 dark:text-white">{{
                    platformUsersFacade.getUserQueryCount(user)
                    }}</span>
                </td>
              </tr>
              }
            </tbody>
          </table>
        </div>
        <div
          class="home-mobile-platform-users-row md:hidden flex gap-3 overflow-x-auto px-4 py-4 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
          @for (user of platformUsersFacade.filteredPlatformUsers; track user.id) {
          <app-platform-user-card class="home-mobile-platform-user-card" [user]="user"
            [initials]="platformUsersFacade.getUserInitials(user)"
            [avatarColor]="platformUsersFacade.getUserAvatarColor(user)"
            [department]="platformUsersFacade.getUserDepartment(user)"
            [agentIcons]="platformUsersFacade.getUserAgentIcons(user)"
            [queryCount]="platformUsersFacade.getUserQueryCount(user)">
          </app-platform-user-card>
          }
        </div>
        }
      </div>
    </div>

    <app-home-recent-chats-section [isLoading]="home.isLoadingChats" [chats]="home.recentChatsView"
      [totalCount]="home.totalChatsCount" (chatSelected)="home.goToChat($event)"
      (viewAllRequested)="home.goToAllChats()"></app-home-recent-chats-section>

    <!-- Novedades ARDIA -->
    <div class="home-mobile-section-shell w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-12">
      <div class="home-mobile-section-heading flex items-start gap-3 mb-4">
        <div class="home-mobile-section-accent w-1 h-8 bg-[#3D3DF4] rounded-full shrink-0"></div>
        <h2 class="text-lg font-bold text-gray-900 dark:text-white leading-tight uppercase tracking-wide">Novedades
          ARDIA</h2>
      </div>
      <div class="home-mobile-updates-grid grid grid-cols-1 md:grid-cols-3 gap-5 -mx-4 px-4 md:mx-0 md:px-0">
        <!-- Card 1: Control de accesos -->
        <div
          class="home-mobile-update-card bg-white dark:bg-[var(--color-dark-bg-secondary)] border border-gray-200 dark:border-gray-700 rounded-2xl p-6 flex flex-col justify-between">
          <div>
            <h3 class="text-[10px] font-bold text-gray-900 dark:text-white uppercase tracking-wider mb-2">Más control
              sobre accesos de usuarios</h3>
            <p class="text-xs text-gray-500 dark:text-gray-400 leading-relaxed">Ahora puedes definir qué agentes puede
              usar cada miembro de tu equipo.</p>
          </div>
          @if (home.isAdmin) {
          <div class="mt-5">
            <a (click)="goToUserManagement()"
              class="text-xs font-semibold text-[#3D3DF4] dark:text-[#5D5DF6] hover:underline cursor-pointer flex items-center gap-1.5">
              Ver cómo funciona
              <fa-icon [icon]="faChevronRight" class="text-[10px] leading-none flex items-center"></fa-icon>
            </a>
          </div>
          }
        </div>
        <!-- Card 2: Respuestas rápidas -->
        <div
          class="home-mobile-update-card bg-white dark:bg-[var(--color-dark-bg-secondary)] border border-gray-200 dark:border-gray-700 rounded-2xl p-6 flex flex-col justify-between">
          <div>
            <h3 class="text-[10px] font-bold text-gray-900 dark:text-white uppercase tracking-wider mb-2">Respuestas más
              rápidas en tus análisis</h3>
            <p class="text-xs text-gray-500 dark:text-gray-400 leading-relaxed">Los agentes ahora procesan documentos y
              datos en segundos para que no tengas que esperar para tomar decisiones.</p>
          </div>
          <div class="mt-5">
            <a (click)="home.newChat()"
              class="text-xs font-semibold text-[#3D3DF4] dark:text-[#5D5DF6] hover:underline cursor-pointer flex items-center gap-1.5">
              Probar ahora
              <fa-icon [icon]="faChevronRight" class="text-[10px] leading-none flex items-center"></fa-icon>
            </a>
          </div>
        </div>
        <!-- Card 3: Contexto empresarial -->
        <div
          class="home-mobile-update-card bg-white dark:bg-[var(--color-dark-bg-secondary)] border border-gray-200 dark:border-gray-700 rounded-2xl p-6 flex flex-col justify-between">
          <div>
            <h3 class="text-[10px] font-bold text-gray-900 dark:text-white uppercase tracking-wider mb-2">Mayor contexto
              empresarial</h3>
            <p class="text-xs text-gray-500 dark:text-gray-400 leading-relaxed">Completa la sección Mi Empresa para
              obtener respuestas más estratégicas y alineadas con tu realidad.</p>
          </div>
          @if (home.isAdmin) {
          <div class="mt-5">
            <a (click)="goToCompanyContext()"
              class="text-xs font-semibold text-[#3D3DF4] dark:text-[#5D5DF6] hover:underline cursor-pointer flex items-center gap-1.5">
              Ver más información
              <fa-icon [icon]="faChevronRight" class="text-[10px] leading-none flex items-center"></fa-icon>
            </a>
          </div>
          }
        </div>
      </div>
    </div>

    <!-- Frase motivacional -->
    <div class="home-mobile-section-shell w-full max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 pb-12">
      <div class="home-mobile-quote text-center py-10 border-t border-gray-100 dark:border-gray-800">
        <p class="text-5xl font-light text-gray-300 dark:text-gray-600 mb-4 select-none">&ldquo;</p>
        <p class="text-lg sm:text-xl italic text-gray-500 dark:text-gray-400 leading-relaxed max-w-2xl mx-auto">
          "{{ home.motivationalPhrase }}"
        </p>
        @if (home.weatherCity) {
        <div class="mt-6">
          <span
            class="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-[#F3F4F6] dark:bg-[var(--color-dark-bg-secondary)] text-xs font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wider">
            <fa-icon [icon]="home.weatherIcon" class="text-sm" [style.color]="home.weatherIconColor"></fa-icon>
            {{ home.weatherCity }}: {{ home.weatherTemp }}, {{ home.weatherDescription }}
          </span>
        </div>
        }
      </div>
    </div>

  </div>

  <!-- Video Modal -->
  <app-video-modal [videoUrl]="modalVideoUrl" [show]="showModal" (close)="closeVideoModal()"></app-video-modal>

  <!-- Add Expert Modal -->
  @if (showAddExpertModal) {
  <app-agents-add-simple-modal (close)="closeAddExpertModal()"
    (createAgent)="onAgentCreated($event)"></app-agents-add-simple-modal>
  }
</div>
